import { useContext } from 'react';
import { IRetarget, ITimerStatus, RetargetContext } from '@vfit/business-data-access';

export const getProductVersion = (id?: string, productVersion?: string, isPrive?: string, retarget?: IRetarget): string => {
  const { checkRetargetActive, versionAEM} = useContext(RetargetContext);
  const currentState = checkRetargetActive({productId: id, version: versionAEM || productVersion, retarget });
  const version = ((versionAEM || productVersion) && (currentState === ITimerStatus.ACTIVE || isPrive === 'true')) && (versionAEM || productVersion);
  return version || '';
}
